// src/components/LicenseBanner.js
import {
  Alert,
  AlertIcon,
  AlertDescription,
  Box,
} from "@chakra-ui/react";
import { getLicenseState } from "../utils/licenseUtils";

export default function LicenseBanner({ status }) {
  if (!status) return null;

  const { is_valid, message } = status;
  const { locked, diffDays, dateText, hasDate } = getLicenseState(status);

  // jei nėra datos apskritai
  if (!hasDate) {
    if (!is_valid) {
      return (
        <Banner
          level="error"
          text={message || "Licencija negalioja."}
        />
      );
    }
    return null;
  }

  // jei jau užrakinta (data praėjusi ar is_valid = 0)
  if (locked) {
    return (
      <Banner
        level="error"
        text={message || `❌ Licencijos galiojimas pasibaigęs (${dateText}). Sistema užrakinta.`}
      />
    );
  }

  // šiandien paskutinė diena
  if (diffDays === 0) {
    return (
      <Banner
        level="warning"
        text={`⚠ Šiandien paskutinė licencijos galiojimo diena (${dateText}).`}
      />
    );
  }

  // likę < 3 dienų
  if (diffDays > 0 && diffDays <= 3) {
    return (
      <Banner
        level="error"
        text={`⚠ Licencija baigsis po ${diffDays} d. (iki ${dateText}). Susisiekite dėl atnaujinimo.`}
      />
    );
  }

  // likę < 7 dienų
  if (diffDays > 3 && diffDays <= 7) {
    return (
      <Banner
        level="warning"
        text={`⚠ Licencija baigsis po ${diffDays} d. (iki ${dateText}).`}
      />
    );
  }

  // daugiau nei 7 dienos – nieko nerodom
  return null;
}

function Banner({ level = "error", text }) {
  return (
    <Box w="100%">
      <Alert status={level} variant="solid" borderRadius="0" justifyContent="center">
        <AlertIcon />
        <AlertDescription fontWeight="bold">
          {text}
        </AlertDescription>
      </Alert>
    </Box>
  );
}
